import Model from "./base/model";

class SimulationTableSuframa extends Model{
  resourceName() {
    return "simulation_table_suframa";
  }

  fields() {
    return {
      simulation_table_id: "",
      state_id: "",
      state: "",
      states: "",
      simulation_table: { jsonApi: "hasOne", type: "simulation_tables"},

    };
  }

}

export default new SimulationTableSuframa();
